module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-17-svgrepo-com.40fb5666.svg";